import dayjs from 'dayjs';
import { useAtom } from 'jotai';
import { atomWithReset, RESET } from 'jotai/utils';
import { useEffect } from 'react';
import { useLiveConsultation } from '~features/live-consultation/hooks/queries/use-live-consultation';

export const spentTimeAtom = atomWithReset('00:00');
spentTimeAtom.debugLabel = 'spentTimeAtom';

const getSpentTime = (created_at: Date) => {
  const spentSeconds = dayjs().diff(dayjs(created_at), 'seconds');
  return new Date(spentSeconds * 1000).toISOString().slice(11, 19);
};

export const useSpentTime = () => {
  const [spentTime, setSpentTime] = useAtom(spentTimeAtom);
  const { data: lc } = useLiveConsultation();

  useEffect(() => {
    if (!lc?.id) {
      return;
    }
    const { created_at } = lc;
    setSpentTime(getSpentTime(created_at));
    const interval = setInterval(() => {
      setSpentTime(getSpentTime(created_at));
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [lc, setSpentTime]);

  const resetSpentTime = () => {
    setSpentTime(RESET);
  };

  return {
    spentTime,
    resetSpentTime
  };
};
